import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface Permiso {
  id: number;
  codigo: string;
  descripcion?: string;
}

export interface UserPermisosResponse {
  usuario_id: number;
  roles: { id: number; nombre: string; descripcion: string }[];
  permisos: Permiso[];
}

@Injectable({
  providedIn: 'root'
})
export class PermisosService {
  private apiUrl = `${environment.apiUrl}/api/permisos`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<Permiso[]> {
    return this.http.get<Permiso[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener permisos:', error);
        return throwError(() => error);
      })
    );
  }
}
